import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  memberUrl: "",
  billing_filter: {},
  payment_request: [],
  collection_Type: "",
  isDonationLayout: false,
  accountTransaction: null,
  selectedDeceased: [],
  selectedMourners: [],
  openRecipients: false,
  addLogo: false,
};

export const CommonStates = createSlice({
  name: "CommonStates",
  initialState,
  reducers: {
    addMemmberUrl: (state, action) => {
      state.memberUrl = action.payload;
    },
    setMembetReset: (state) => initialState,
    savefilter: (state, action) => {
      state.billing_filter = action.payload;
    },
    addPaymentRequest: (state, action) => {
      state.payment_request = action.payload;
    },
    setIsDonationLayout: (state, action) => {
      state.isDonationLayout = action.payload;
    },
    setAccountTransaction: (state, action) => {
      state.accountTransaction = action.payload;
    },
    setSelectedDeceased: (state, action) => {
      state.selectedDeceased = action.payload;
    },
    setSelectedMourners: (state, action) => {
      state.selectedMourners = action.payload;
    },
    setOpenRecipients: (state, action) => {
      state.openRecipients = action.payload;
    },
    setAddLogo: (state, action) => {
      state.addLogo = action.payload;
    },
  },
});

export const {
  addMemmberUrl,
  reset,
  savefilter,
  addPaymentRequest,
  resetFilter,
  setIsDonationLayout,
  setAccountTransaction,
  setSelectedDeceased,
  setSelectedMourners,
  setOpenRecipients,
  setAddLogo,
} = CommonStates.actions;
export default CommonStates.reducer;
